import React from 'react';

const GestaoEnvioConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/gestaoEnvio',
      component: React.lazy(() => import('./GestaoEnvio')),
    },
  ],
};

export default GestaoEnvioConfig;
